import React, { Component } from 'react';
import ReactDOM from 'react-dom/client';
import scanIcon from 'images/barcode.png';
import ReadBarcode from 'library/readBarcode';
import LOOKUP from 'constants/lookup';
// Basic Components
import Button from 'screens/components/basic/Button';
import TextInput from 'screens/components/basic/TextInput';
import MinusAndPlusInput from 'screens/components/basic/MinusAndPlusInput';
import Barcode from 'screens/components/basic/Barcode';
import DialogHeader from 'screens/components/basic/DialogHeader';
// Advanced Components
import DialogInputNew from 'screens/components/advanced/DialogInputNew';

class ScanBarcode extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showInput: false,
            showLotNumberInput: false,
            printLabelDialog: false,
            barcode: "",
            quantity: "",
            productName: "",
            store: "",
            price: ''
        }

        this.ws = this.props.ws;
        this.barcode = new ReadBarcode();
    }

    componentDidMount() {
        window.addEventListener("keypress", this.barcodeListener);
    }

    componentWillUnmount() {
        window.removeEventListener("keypress", this.barcodeListener);
    }

    barcodeListener = () => {
        this.barcode.listening(this.props.setUpc)
    }

    showInputText = () => {
        this.setState({ showInput: true });
        window.removeEventListener("keypress", this.barcodeListener);
    }

    showLotNumberInput = () => {
        this.setState({ showLotNumberInput: true });
        window.removeEventListener("keypress", this.barcodeListener);
    }

    printLabel = (barcode) => {
        this.setState(pState => {
            return {
                ...pState,
                barcode: barcode,
                quantity: 1,
                productName: this.props.productInfo.productName,
                store: this.props.store.name,
                price: this.props.productInfo.price
            }
        }, this.printByJs);
    }

    printByJs = () => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.setState({ printLabelDialog: true });
        } else {
            render (<Barcode code={this.state.barcode} format={"CODE128B"} width={2} print={true} />, document.getElementById('to-print'));
        }
    }

    closePrintLabelDialog = () => {
        this.setState({ printLabelDialog: false });
    }

    printByService = () => {
        const model = {
            command: "PRINT BARCODE",
            data: JSON.stringify([{
                CompanyName: this.props.store.name,
                ProductName: this.state.productName,
                Quantity: 1,
                Barcode: this.state.barcode,
                NumberOfCopies: this.props.printQuantity,
                Price: this.state.price
            }])
        };

        console.log(model);

        this.ws.send(JSON.stringify(model));
        this.closePrintLabelDialog()
    }

    saveToPDF = (barcode) => {
        this.setState(pState => {
            return {
                ...pState,
                barcode: barcode
            };
        }, this.saveToPDFDialog);
    }

    saveToPDFDialog = () => {
        const toPrint = ReactDOM.createRoot(document.getElementById('to-print'));
        toPrint.render (<Barcode code={this.state.barcode} format={"CODE128B"} width={2} print={true} />);
    }

    render() {
        return (
            <div>
                <div className="text-center">
                    {
                        (this.props.productInfo.accessory)
                            ?
                            <div>
                                <br />
                                <Button
                                    type="FlatButtonPrimary"
                                    label="Print By Label Printer"
                                    secondary={false}
                                    onTouchTap={() => this.printLabel('Z' + (`00000000000${this.props.productInfo.id}`).slice(-11))}
                                />
                                <br />
                                <br />
                                <Button
                                    type="FlatButtonPrimary"
                                    label="Save Label To PDF"
                                    secondary={false}
                                    onTouchTap={() => this.saveToPDF('Z' + (`00000000000${this.props.productInfo.id}`).slice(-11))}
                                />
                            </div>

                            : ''
                    }
                    <h2 className="pb-2">Scan Barcode</h2>

                    <div className="message-required">
                        {this.props.isMedical || this.props.isVape || this.props.productInfo.accessory ? <span className="label-not-required">Barcode is not mandatory</span> : <span className="label-required">Barcode is mandatory</span>}
                    </div>

                    <div className="img_centered">
                        <img src={scanIcon} />
                    </div>
                    {/* If the code is not validated, show error message */}
                    <div className="">
                        <h3>{this.props.productInfo.upc}</h3>
                        {
                            (!this.props.productInfo.upc && !this.state.showLotNumberInput)
                                ?
                                <div>
                                    <Button
                                        type="FlatButtonPrimary"
                                        label="Input Barcode"
                                        secondary={false}
                                        onTouchTap={this.showInputText}
                                    />
                                </div>
                                : ''
                        }
                        {
                            (this.state.showInput && !this.props.productInfo.upc)
                                ? <div className="centered pb-5">
                                    <TextInput
                                        name={'InputUPCNumber'}
                                        hintText={"Barcode Number"}
                                        fullWidth={true}
                                        className="input-center"
                                        label="Barcode Number"
                                    />
                                </div>
                                : ''
                        }
                        <hr />
                        {
                            (!this.props.isVape && !this.props.productInfo.upc && !this.state.showInput && !this.props.productInfo.accessory)
                                ? <Button
                                    type="FlatButtonPrimary"
                                    label="Input Lot Number"
                                    id="inputLotNumberButton"
                                    secondary={false}
                                    onTouchTap={this.showLotNumberInput}
                                />
                                : ''
                        }
                        {
                            (!this.props.isVape && this.state.showLotNumberInput && !this.props.productInfo.upc)
                                ? <div className="centered pb-5">
                                    <TextInput
                                        name={'InputLotNumber'}
                                        hintText={"Lot Number"}
                                        fullWidth={true}
                                        className="input-center"
                                        label="Lot Number"
                                    />
                                </div>
                                : ''
                        }
                    </div>
                </div>
                <DialogInputNew
                    title={<DialogHeader text={LOOKUP.product.printLabelDialog.title} />}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancel"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.closePrintLabelDialog()} />,
                        <Button
                            key={2}
                            name="ConfirmButton"
                            label={LOOKUP.product.printLabelDialog.print.label}
                            primary={true}
                            onTouchTap={this.printByService}
                        />]}
                    className="printLabelProduct"
                    open={this.state.printLabelDialog}
                >
                    <div className="row d-flex justify-content-center printLabel">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                            <MinusAndPlusInput
                                name="labelQuantityProductBarcode"
                                minimum="1"
                                maximum="1000"
                            />
                        </div>
                    </div>
                </DialogInputNew>
            </div>
        );
    }
}

export default ScanBarcode;